import React from 'react';
import './GameBoard.css';

function GameBoard({ size, sequence, showingAllColors, onCellClick, revealedCells, colors }) {
  const renderCell = (row, col) => {
    // Check if there's a color at this position in the sequence
    const sequenceItem = sequence.find(
      item => item.position.row === row && item.position.col === col
    );

    // Check if this cell has been revealed by the user
    const revealedCell = revealedCells.find(
      cell => cell.row === row && cell.col === col
    );

    let cellStyle = {};
    let cellClass = 'cell';

    if (showingAllColors && sequenceItem) {
      // Showing all colors initially
      cellStyle.backgroundColor = colors[sequenceItem.color];
      cellClass += ' displaying';
    } else if (revealedCell) {
      // User has clicked and revealed this cell
      cellStyle.backgroundColor = colors[revealedCell.color];
      cellClass += ' revealed';
    }

    return (
      <div
        key={`${row}-${col}`}
        className={cellClass}
        style={cellStyle}
        onClick={() => onCellClick(row, col)}
      />
    );
  };

  return (
    <div className={`game-board size-${size}`}>
      {Array.from({ length: size }).map((_, row) =>
        Array.from({ length: size }).map((_, col) => renderCell(row, col))
      )}
    </div>
  );
}

export default GameBoard;
